export const TYPE_STORY = 'STORY';
export const TYPE_VISUAL_CLOUD = 'VISUAL_CLOUD';
export const TYPE_WORD_CLOUD = 'WORD_CLOUD';
export const TYPE_TIMELINE = 'TIMELINE';